import { Link } from 'react-router-dom';
import { Button } from '../button';
type Props = {
  goBackHref?: string;
};
const DataNotFound = ({ goBackHref }: Props) => {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Data not found
        </h1>
        <p className="mt-6 text-base leading-7 text-muted-foreground">
          Sorry, we couldn’t find the data you’re looking for.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link to={goBackHref || '/'}>
            <Button>Go back</Button>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default DataNotFound;
